import React from 'react'
import PropTypes from 'prop-types'
import { DefaultSeo, NextSeo } from 'next-seo'

import seo from '@/seo'

// The head describes this site only: no structured data and no page URL.
const Seo = ({ pageId, shouldRobotsIndex }) => {
  const noPageId = pageId === 'notFound'
  const robotsContent = shouldRobotsIndex ? {} : { noindex: true, nofollow: true }
  const notFound = noPageId ? { noindex: true, nofollow: false } : {}

  return (
    <>
      <DefaultSeo {...seo.default} />
      <NextSeo
        {...seo[pageId]}
        {...robotsContent}
        {...notFound}
        robotsProps={shouldRobotsIndex && !noPageId ? {
          maxImagePreview: 'large',
          maxSnippet: -1,
          maxVideoPreview: -1,
        } : {}}
      />
    </>
  )
}

Seo.propTypes = {
  pageId: PropTypes.string,
  shouldRobotsIndex: PropTypes.bool,
}

export default Seo
